import Alpine from "alpinejs";

/** Only one item open at a time: opening an item closes the others, clicking it again closes it. */
Alpine.data("accordion", () => ({
  active: null as number | null,
  init() {},
  destroy() {},
  isOpen(index: number) {
    return this.active === index;
  },
  toggle(index: number) {
    this.active = this.isOpen(index) ? null : index;
  },
}));
